export default "Exonération CSPE industrie — Électro-intensité & procédés exonérés | Solution Éco France";
